import sortBy from "lodash/sortBy";

export default {
  state: {
    allCompanies: []
  },
  mutations: {
    setAllCompanies(state, payload) {
      state.allCompanies = payload;
    },
    appendCompany(state, company) {
      state.allCompanies.push(company);
    }
  },
  actions: {
    setAllCompanies({ commit }, payload) {
      commit("setAllCompanies", payload);
    }
  },
  getters: {
    allCompanies(state) {
      return sortBy(state.allCompanies, ["title"]);
    }
  }
};
